/* Custom Reaven — apertura del mega menu al passaggio del mouse.
   Solo puntatore mouse (i tap su schermi touch restano al click nativo).
   Usa il click sul <summary> così Dawn (DetailsDisclosure/HeaderMenu) mantiene aria e posizione;
   chiude su uscita solo se era stato lo hover ad aprire; chiude gli altri pannelli quando ne apre uno. */
(() => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const CLOSE_DELAY = 260;
  const panels = Array.from(document.querySelectorAll('header-menu > details.mega-menu'));

  panels.forEach((details) => {
    const item = details.closest('li') || details;
    const summary = details.querySelector('summary');
    let timer = null;
    let openedByHover = false;

    item.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'mouse') return;
      clearTimeout(timer);
      panels.forEach((other) => {
        if (other !== details && other.open) other.querySelector('summary').click();
      });
      if (!details.open) {
        openedByHover = true;
        summary.click();
      }
    });

    item.addEventListener('pointerleave', (event) => {
      if (event.pointerType !== 'mouse') return;
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (details.open && openedByHover) {
          if (details.contains(document.activeElement)) summary.focus();
          summary.click();
        }
        openedByHover = false;
      }, CLOSE_DELAY);
    });

    details.addEventListener('toggle', () => {
      if (!details.open) openedByHover = false;
    });
  });
})();
